import Vue from 'vue'
import Vuex from 'vuex'
// import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const modules = {}
const requireContext = require.context('./modules', true, /.*\.js$/)
requireContext.keys().forEach(file => {
  const name = file.replace(/(^.\/)|(\.js$)/g, '')
  modules[name] = requireContext(file).default
})

// plugins: [createPersistedState()] 
export default new Vuex.Store({
  modules,
})



// WEBPACK FOOTER //
// ./src/store/index.js